import { Dispatch, SetStateAction } from "react"
import { chMedicationFragmentInline$data } from "@/modules/patients/detail/medication/ch/services/__generated__/chMedicationFragmentInline.graphql"
import { useChMedicationRelationsByDiagnosisCode } from "@/modules/patients/detail/medication/ch/services/ch-medication-relations-by-diagnosis-code"
import {
  ChMedicationSearch,
  MedicationDetail,
} from "@/modules/patients/detail/medication/components/ch-medication-search"
import { Language } from "@/types/__generated__/union-types"

type ChMedicationSearchWrapperProps = {
  existingMedications?: { title: string; options: chMedicationFragmentInline$data[] }[]
  includeTemplates: boolean
  patientLanguage: Language
  className?: string
  useMedicationIcon?: boolean
  isPrescription?: boolean
  error?: string
  handleSelectMedication: (medication: MedicationDetail) => void
  handleFreeTextMedicationSelection: (inputValue: string) => void
  handleSelectExistingMedication: (item: chMedicationFragmentInline$data, medication?: MedicationDetail) => void
  medicationSearchText?: string | null
  setMedicationSearchText?: Dispatch<SetStateAction<string | null>>
  patientId: string
  appointmentId: string
  diagnosisCode: string
}

export const ChMedicationSearchWrapper = (props: ChMedicationSearchWrapperProps) => {
  const {
    existingMedications,
    error,
    handleSelectMedication,
    handleFreeTextMedicationSelection,
    handleSelectExistingMedication,
    medicationSearchText,
    setMedicationSearchText,
    patientId,
    appointmentId,
    patientLanguage,
    diagnosisCode,
    isPrescription,
  } = props

  const data = useChMedicationRelationsByDiagnosisCode(patientId, diagnosisCode, appointmentId)

  return (
    <ChMedicationSearch
      includeTemplates
      usePopover={isPrescription}
      className="max-h-92.5 p-2"
      patientLanguage={patientLanguage}
      existingMedications={existingMedications}
      error={error}
      handleSelectMedication={handleSelectMedication}
      handleFreeTextMedicationSelection={handleFreeTextMedicationSelection}
      handleSelectExistingMedication={handleSelectExistingMedication}
      medicationSearchText={medicationSearchText}
      setMedicationSearchText={setMedicationSearchText}
      patientId={patientId}
      appointmentId={appointmentId}
      medicationRelationsByDiagnosisCode={data?.ch_medicationRelationsByDiagnosisCode}
    />
  )
}
